export const PAYMENT_FAILURE_REASON_TEXTS = {
  uk: {
    visa_blocked: 'Оплата карткою МПС VISA недоступна',
    limit_customer_number_day: 'Перевищено денний ліміт операцій',
    limit_customer_sum_month: 'Перевищено місячний ліміт суми операцій',
    limit_card_sum_month: 'Перевищено місячний ліміт суми операцій за карткою',
    limit_card_number_day: 'Перевищено денний ліміт операцій за карткою.',
    foreign_card: 'Оплата карткою цієї країни недоступна',
    customer_data_empty: 'Недостатньо даних для проведення оплати.',
    prro_tax_not_2_or_7: 'Некоректні параметри оплати.',
    blocked_by_firewall:
      'Операцію відхилено відповідно до внутрішніх правил безпеки сервісу. \nРекомендуємо скористатись іншою картою',
  },
  ru: {
    visa_blocked: 'Оплата картой МПС VISA недоступна',
    limit_customer_number_day: 'Превышен дневной лимит операций',
    limit_customer_sum_month: 'Превышен месячный лимит суммы операций',
    limit_card_sum_month: 'Превышен месячный лимит суммы операций по карте',
    limit_card_number_day: 'Превышен дневной лимит операций по карте',
    foreign_card: 'Оплата картой, выпущенной в этой стране, недоступна',
    customer_data_empty: 'Недостаточно данных для проведения оплаты',
    prro_tax_not_2_or_7: 'Некорректные параметры оплаты',
    blocked_by_firewall:
      'Операция отклонена в соответствии с внутренними правилами безопасности сервиса.\nРекомендуем воспользоваться другой картой',
  },
  en: {
    visa_blocked: 'Payments with VISA cards are not available',
    limit_customer_number_day: 'Daily transaction limit exceeded',
    limit_customer_sum_month: 'Monthly transaction amount limit exceeded',
    limit_card_sum_month: 'Monthly card transaction amount limit exceeded',
    limit_card_number_day: 'Daily card transaction limit exceeded',
    foreign_card: 'Payments with cards issued in this country are not available',
    customer_data_empty: 'Insufficient data to process the payment',
    prro_tax_not_2_or_7: 'Invalid payment parameters',
    blocked_by_firewall:
      'The operation was declined due to internal security rules.\nWe recommend using a different payment card',
  },
  pt: {
    visa_blocked: 'Pagamentos com cartões VISA não estão disponíveis',
    limit_customer_number_day: 'Limite diário de transações excedido',
    limit_customer_sum_month: 'Limite mensal do valor das transações excedido',
    limit_card_sum_month: 'Limite mensal do valor de transações do cartão excedido',
    limit_card_number_day: 'Limite diário de transações do cartão excedido',
    foreign_card: 'Pagamentos com cartões emitidos neste país não estão disponíveis',
    customer_data_empty: 'Dados insuficientes para processar o pagamento',
    prro_tax_not_2_or_7: 'Parâmetros de pagamento inválidos',
    blocked_by_firewall:
      'A operação foi recusada devido às regras internas de segurança.\nRecomendamos usar outro cartão de pagamento',
  },
  es: {
    visa_blocked: 'Los pagos con tarjetas VISA no están disponibles',
    limit_customer_number_day: 'Se ha superado el límite diario de transacciones',
    limit_customer_sum_month: 'Se ha superado el límite mensual del importe de transacciones',
    limit_card_sum_month:
      'Se ha superado el límite mensual del importe de transacciones de la tarjeta',
    limit_card_number_day: 'Se ha superado el límite diario de transacciones de la tarjeta',
    foreign_card: 'Los pagos con tarjetas emitidas en este país no están disponibles',
    customer_data_empty: 'Datos insuficientes para procesar el pago',
    prro_tax_not_2_or_7: 'Parámetros de pago no válidos',
    blocked_by_firewall:
      'La operación fue rechazada debido a reglas internas de seguridad.\nRecomendamos usar otra tarjeta de pago',
  },
  sw: {
    visa_blocked: 'Malipo kwa kadi za VISA hayapatikani',
    limit_customer_number_day: 'Kikomo cha kila siku cha miamala kimezidi',
    limit_customer_sum_month: 'Kikomo cha kila mwezi cha kiasi cha miamala kimezidi',
    limit_card_sum_month: 'Kikomo cha kila mwezi cha kiasi cha miamala ya kadi kimezidi',
    limit_card_number_day: 'Kikomo cha kila siku cha miamala ya kadi kimezidi',
    foreign_card: 'Malipo kwa kadi zilizotolewa katika nchi hii hayapatikani',
    customer_data_empty: 'Data hazitoshi kuchakata malipo',
    prro_tax_not_2_or_7: 'Vigezo vya malipo si sahihi',
    blocked_by_firewall:
      'Muamala ulikataliwa kutokana na sheria za ndani za usalama.\nTunapendekeza utumie kadi nyingine ya malipo',
  },
  uz: {
    visa_blocked: "VISA kartalari bilan to'lovlar mavjud emas",
    limit_customer_number_day: "Kunlik tranzaksiya limiti oshib ketdi",
    limit_customer_sum_month: "Oylik tranzaksiya summasi limiti oshib ketdi",
    limit_card_sum_month: "Karta bo'yicha oylik tranzaksiya summasi limiti oshib ketdi",
    limit_card_number_day: "Karta bo'yicha kunlik tranzaksiya limiti oshib ketdi",
    foreign_card: "Ushbu mamlakatda chiqarilgan kartalar bilan to'lovlar mavjud emas",
    customer_data_empty: "To'lovni amalga oshirish uchun ma'lumotlar yetarli emas",
    prro_tax_not_2_or_7: "To'lov parametrlari noto'g'ri",
    blocked_by_firewall:
      "Operatsiya ichki xavfsizlik qoidalariga ko'ra rad etildi.\nBoshqa to'lov kartasidan foydalanishni tavsiya qilamiz",
  },
  de: {
    visa_blocked: 'Zahlungen mit VISA-Karten sind nicht verfügbar',
    limit_customer_number_day: 'Tägliches Transaktionslimit überschritten',
    limit_customer_sum_month: 'Monatliches Limit für Transaktionsbeträge überschritten',
    limit_card_sum_month: 'Monatliches Limit für Kartentransaktionsbeträge überschritten',
    limit_card_number_day: 'Tägliches Limit für Kartentransaktionen überschritten',
    foreign_card:
      'Zahlungen mit Karten, die in diesem Land ausgestellt wurden, sind nicht verfügbar',
    customer_data_empty: 'Unzureichende Daten zur Verarbeitung der Zahlung',
    prro_tax_not_2_or_7: 'Ungültige Zahlungsparameter',
    blocked_by_firewall:
      'Der Vorgang wurde aufgrund interner Sicherheitsregeln abgelehnt.\nWir empfehlen, eine andere Zahlungskarte zu verwenden',
  },
  tr: {
    visa_blocked: 'VISA kartlarıyla ödeme yapılamıyor',
    limit_customer_number_day: 'Günlük işlem limiti aşıldı',
    limit_customer_sum_month: 'Aylık işlem tutarı limiti aşıldı',
    limit_card_sum_month: 'Aylık kart işlem tutarı limiti aşıldı',
    limit_card_number_day: 'Günlük kart işlem limiti aşıldı',
    foreign_card: 'Bu ülkede verilmiş kartlarla ödeme yapılamıyor',
    customer_data_empty: 'Ödemeyi işlemek için yeterli veri yok',
    prro_tax_not_2_or_7: 'Geçersiz ödeme parametreleri',
    blocked_by_firewall:
      'İşlem, dahili güvenlik kuralları nedeniyle reddedildi.\nFarklı bir ödeme kartı kullanmanızı öneririz',
  },
  fr: {
    visa_blocked: 'Les paiements par cartes VISA ne sont pas disponibles',
    limit_customer_number_day: 'Limite quotidienne de transactions dépassée',
    limit_customer_sum_month: 'Limite mensuelle du montant des transactions dépassée',
    limit_card_sum_month: 'Limite mensuelle du montant des transactions par carte dépassée',
    limit_card_number_day: 'Limite quotidienne des transactions par carte dépassée',
    foreign_card: 'Les paiements avec des cartes émises dans ce pays ne sont pas disponibles',
    customer_data_empty: 'Données insuffisantes pour traiter le paiement',
    prro_tax_not_2_or_7: 'Paramètres de paiement non valides',
    blocked_by_firewall:
      "L'opération a été refusée en raison des règles de sécurité internes.\nNous vous recommandons d'utiliser une autre carte de paiement",
  },
  it: {
    visa_blocked: 'I pagamenti con carte VISA non sono disponibili',
    limit_customer_number_day: 'Limite giornaliero delle transazioni superato',
    limit_customer_sum_month: "Limite mensile dell'importo delle transazioni superato",
    limit_card_sum_month: "Limite mensile dell'importo delle transazioni con carta superato",
    limit_card_number_day: 'Limite giornaliero delle transazioni con carta superato',
    foreign_card: 'I pagamenti con carte emesse in questo Paese non sono disponibili',
    customer_data_empty: 'Dati insufficienti per elaborare il pagamento',
    prro_tax_not_2_or_7: 'Parametri di pagamento non validi',
    blocked_by_firewall:
      "L'operazione è stata rifiutata a causa delle regole di sicurezza interne.\nConsigliamo di utilizzare un'altra carta di pagamento",
  },
  az: {
    visa_blocked: 'VISA kartları ilə ödənişlər mümkün deyil',
    limit_customer_number_day: 'Gündəlik əməliyyat limiti aşılıb',
    limit_customer_sum_month: 'Aylıq əməliyyat məbləği limiti aşılıb',
    limit_card_sum_month: 'Kart üzrə aylıq əməliyyat məbləği limiti aşılıb',
    limit_card_number_day: 'Kart üzrə gündəlik əməliyyat limiti aşılıb',
    foreign_card: 'Bu ölkədə buraxılmış kartlarla ödənişlər mümkün deyil',
    customer_data_empty: 'Ödənişi emal etmək üçün məlumat kifayət deyil',
    prro_tax_not_2_or_7: 'Ödəniş parametrləri yanlışdır',
    blocked_by_firewall:
      'Əməliyyat daxili təhlükəsizlik qaydalarına görə rədd edildi.\nBaşqa ödəniş kartından istifadə etməyi tövsiyə edirik',
  },
  pl: {
    visa_blocked: 'Płatności kartami VISA są niedostępne',
    limit_customer_number_day: 'Przekroczono dzienny limit transakcji',
    limit_customer_sum_month: 'Przekroczono miesięczny limit kwoty transakcji',
    limit_card_sum_month: 'Przekroczono miesięczny limit kwoty transakcji kartą',
    limit_card_number_day: 'Przekroczono dzienny limit transakcji kartą',
    foreign_card: 'Płatności kartami wydanymi w tym kraju są niedostępne',
    customer_data_empty: 'Niewystarczające dane do przetworzenia płatności',
    prro_tax_not_2_or_7: 'Nieprawidłowe parametry płatności',
    blocked_by_firewall:
      'Operacja została odrzucona zgodnie z wewnętrznymi zasadami bezpieczeństwa.\nZalecamy użycie innej karty płatniczej',
  },
  ud: {
    visa_blocked: 'VISA کارڈز سے ادائیگیاں دستیاب نہیں ہیں',
    limit_customer_number_day: 'روزانہ ٹرانزیکشنز کی حد سے تجاوز ہو گیا ہے',
    limit_customer_sum_month: 'ماہانہ ٹرانزیکشن رقم کی حد سے تجاوز ہو گیا ہے',
    limit_card_sum_month: 'ماہانہ کارڈ ٹرانزیکشن رقم کی حد سے تجاوز ہو گیا ہے',
    limit_card_number_day: 'روزانہ کارڈ ٹرانزیکشنز کی حد سے تجاوز ہو گیا ہے',
    foreign_card: 'اس ملک میں جاری کردہ کارڈز سے ادائیگیاں دستیاب نہیں ہیں',
    customer_data_empty: 'ادائیگی پر کارروائی کے لیے ناکافی معلومات',
    prro_tax_not_2_or_7: 'ادائیگی کے پیرامیٹرز غلط ہیں',
    blocked_by_firewall:
      'داخلی سیکیورٹی قواعد کی وجہ سے کارروائی مسترد کر دی گئی۔\nہم کوئی دوسرا ادائیگی کارڈ استعمال کرنے کی تجویز دیتے ہیں',
  },
  ja: {
    visa_blocked: 'VISAカードでのお支払いはご利用いただけません',
    limit_customer_number_day: '1日の取引上限を超過しました',
    limit_customer_sum_month: '月間取引金額の上限を超過しました',
    limit_card_sum_month: 'カードの月間取引金額上限を超過しました',
    limit_card_number_day: 'カードの1日取引上限を超過しました',
    foreign_card: 'この国で発行されたカードでのお支払いはご利用いただけません',
    customer_data_empty: '支払いを処理するためのデータが不足しています',
    prro_tax_not_2_or_7: '支払いパラメータが無効です',
    blocked_by_firewall:
      '内部セキュリティルールにより取引が拒否されました。\n別の支払いカードのご利用をおすすめします',
  },
  zh: {
    visa_blocked: '无法使用 VISA 卡付款',
    limit_customer_number_day: '已超出每日交易限额',
    limit_customer_sum_month: '已超出每月交易金额限额',
    limit_card_sum_month: '已超出每月卡交易金额限额',
    limit_card_number_day: '已超出每日卡交易限额',
    foreign_card: '无法使用该国家/地区发行的卡付款',
    customer_data_empty: '处理付款所需的数据不足',
    prro_tax_not_2_or_7: '付款参数无效',
    blocked_by_firewall: '该操作因内部安全规则被拒绝。\n建议使用其他支付卡',
  },
  'zh-hant': {
    visa_blocked: '無法使用 VISA 卡付款',
    limit_customer_number_day: '已超出每日交易限額',
    limit_customer_sum_month: '已超出每月交易金額限額',
    limit_card_sum_month: '已超出每月卡片交易金額限額',
    limit_card_number_day: '已超出每日卡片交易限額',
    foreign_card: '無法使用該國家/地區發行的卡付款',
    customer_data_empty: '處理付款所需的資料不足',
    prro_tax_not_2_or_7: '付款參數無效',
    blocked_by_firewall: '該操作因內部安全規則被拒絕。\n建議使用其他付款卡',
  },
};
